import { useSearchParams } from "react-router-dom";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import "./setting.scss";
import PageContainer from "../layouts/PageContainer";
import { PageHeader } from "../ui";
import LocationsList from "./locations/LocationsList";
import MachinesByLocation from "./machines/MachinesByLocation";
import CmmsSettings from "./cmms/CmmsSettings";
import OneUptimeSettings from "./oneuptime/OneUptimeSettings";
import DiscordAlertsSettings from "./discord/DiscordAlertsSettings";

const TABS = [
  { id: "locations", label: "Locations", render: () => <LocationsList /> },
  { id: "machines", label: "Machines", render: () => <MachinesByLocation /> },
  { id: "cmms", label: "CMMS (Nitro)", render: () => <CmmsSettings /> },
  { id: "oneuptime", label: "OneUptime", render: () => <OneUptimeSettings /> },
  { id: "discord", label: "Discord alerts", render: () => <DiscordAlertsSettings /> },
];

export default function Setting() {
  // Held in the URL so a tab can be linked to and survives a refresh.
  const [searchParams, setSearchParams] = useSearchParams();
  const requested = searchParams.get("tab");
  const active = TABS.find((t) => t.id === requested) ?? TABS[0];

  return (
    <PageContainer>
      <PageHeader title="Settings" />
      <div className="sq-settings-tabs">
        <Tabs
          value={active.id}
          onChange={(_e, id: string) => setSearchParams({ tab: id }, { replace: true })}
          variant="scrollable"
          scrollButtons={false}
          aria-label="Settings sections"
        >
          {TABS.map((t) => (
            <Tab key={t.id} value={t.id} label={t.label} />
          ))}
        </Tabs>
      </div>
      {active.render()}
    </PageContainer>
  );
}
